import type { ISafetyComplianceCard } from '@interfaces/ISafetyCompliance';
import { authedFetch, UnauthorizedError } from '@apis/auth';

export async function fetchSafetyCompliance(
  siteId: string,
  signal?: AbortSignal,
): Promise<ISafetyComplianceCard> {
  const res = await authedFetch(`/api/sites/${siteId}/safety-compliance`, { signal });
  if (res.ok) return (await res.json()) as ISafetyComplianceCard;

  const body = await res.json().catch(() => null);
  if (res.status === 401) throw new UnauthorizedError();
  throw new Error(body?.error?.message ?? 'Safety data is currently unavailable');
}
